export default __webpack_public_path__ + "static/media/passenger-color.63717b6d.svg";